/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const RevenueReportPage = lazyLoad(
  () => import('./index'),
  module => module.RevenueReportPage
);
